import { useState, useContext, useEffect } from 'react';
//import { sendOtp } from '../../api/auth';
import { register } from '../../api/auth';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import Swal from 'sweetalert2';
import '../../styles/register.css';

function Register() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    emailId: '',
    password: '',
    confirmPassword: '',
    contactNumber: '',
    countryOrRegion: '',
  });

  const [loading, setLoading] = useState(false);

  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from || '/';

  // Redirect if already logged in
  useEffect(() => {
    if (user) {
      navigate(from, { replace: true });
    }
  }, [user, from, navigate]);

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Password match check
    if (formData.password !== formData.confirmPassword) {
      Swal.fire({
        icon: 'error',
        title: 'Password Mismatch',
        text: 'Password and Confirm Password must match',
      });
      return;
    }

    try {
      setLoading(true);

      // 🔐 Send OTP instead of creating account directly
      //await sendOtp(formData);
await register(formData);
      Swal.fire({
        icon: 'success',
        title: 'OTP Sent',
        text: 'We have sent a verification code to your email',
      });

      // Redirect to OTP verification screen
      navigate('/verify-otp', {
        state: { emailId: formData.emailId },
      });

    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Registration Failed',
        text: error.response?.data?.message || 'Unable to send OTP',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="register-container">
      <h2>Create an Account</h2>

      <form onSubmit={handleSubmit}>
        <input
          type="text"
          name="firstName"
          placeholder="First Name"
          value={formData.firstName}
          onChange={handleChange}
          required
        />

        <input
          type="text"
          name="lastName"
          placeholder="Last Name"
          value={formData.lastName}
          onChange={handleChange}
          required
        />

        <input
          type="email"
          name="emailId"
          placeholder="Email"
          value={formData.emailId}
          onChange={handleChange}
          required
        />

        <input
          type="password"
          name="password"
          placeholder="Password"
          value={formData.password}
          onChange={handleChange}
          required
        />

        <input
          type="password"
          name="confirmPassword"
          placeholder="Confirm Password"
          value={formData.confirmPassword}
          onChange={handleChange}
          required
        />

        <input
          type="tel"
          name="contactNumber"
          placeholder="Contact Number"
          value={formData.contactNumber}
          onChange={handleChange}
          required
        />

        <input
          type="text"
          name="countryOrRegion"
          placeholder="Country / Region"
          value={formData.countryOrRegion}
          onChange={handleChange}
          required
        />

        <button type="submit" disabled={loading}>
          {loading ? 'Sending OTP...' : 'Register'}
        </button>
      </form>

      <p className="redirect-text">
        Already registered?{' '}
        <Link to="/login" className="login-link">
          Login here
        </Link>
      </p>
    </div>
  );
}

export default Register;
